// extracted by mini-css-extract-plugin
export default {"controls":"carousel-module__controls___XQPjd","previous":"carousel-module__previous___IfM5M","next":"carousel-module__next___ZpMh_"};